// extracted by mini-css-extract-plugin
export var actionButton = "_pl-0";
export var actionMenuContainer = "_pl-i";
export var bubble = "_pl-2";
export var bubbleActionMenu = "_pl-j";
export var bubbleContext = "_pl-6";
export var bubbleItems = "_pl-7";
export var customer = "_pl-3";
export var divider = "_pl-8";
export var fileList = "_pl-9";
export var hiddenComment = "_pl-o";
export var infoAbove = "_pl-a";
export var internal = "_pl-4";
export var lightActionButton = "_pl-1";
export var link = "_pl-b";
export var merchant = "_pl-5";
export var message = "_pl-c";
export var profilePicture = "_pl-e";
export var quillToolbarContainer = "_pl-f";
export var senderDate = "_pl-g";
export var senderDateCustomer = "_pl-h";
export var senderName = "_pl-d";
export var time = "_pl-k";
export var uploadedImage = "_pl-l";
export var username = "_pl-m";
export var xsmall = "_pl-n";